import { Component, Inject } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

// dialog component
@Component({
  selector: 'app-profile-pic-preview',
  templateUrl: './profile-pic-preview.component.html',
  styleUrls: ['./profile-pic-preview.component.scss']
})
export class ProfilePicPreviewComponent {
  src: any;

  constructor(public dialogRef: MatDialogRef<ProfilePicPreviewComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {
    this.src = data.filesrc;
  }

  // triggers the close event
  onCancel(event): void {
    this.dialogRef.close();
  }

}

// bottom sheet component
@Component({
  selector: 'app-profile-pic-preview-bottom-sheet',
  templateUrl: './profile-pic-preview.component.html',
  styleUrls: ['./profile-pic-preview.component.scss']
})
export class ProfilePicPreviewBottomSheetComponent {
  constructor(private _bottomSheetRef: MatBottomSheetRef<ProfilePicPreviewBottomSheetComponent>, @Inject(MAT_BOTTOM_SHEET_DATA) public data: any) {
    this.src = data.filesrc;
  }
  src;

  // triggers the close event
  onCancel(event): void {
    this._bottomSheetRef.dismiss();
    event.preventDefault();
  }
}


